export const _setValue = (prefix) => (items) => ({
    type: prefix,
    payload: items
})
